import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toast"
export default class extends Controller {
  static values = {
    autoDismiss: { type: Boolean, default: false },
    duration: { type: Number, default: 5000 },
  }

  connect() {
    requestAnimationFrame(() => {
      this.element.classList.remove("translate-y-[-1rem]", "opacity-0")
      this.element.classList.add("translate-y-0", "opacity-100")
    })

    if (this.autoDismissValue) {
      this.timeout = setTimeout(() => this.dismiss(), this.durationValue)
    }
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  dismiss() {
    this.element.classList.remove("translate-y-0", "opacity-100")
    this.element.classList.add("translate-y-[-1rem]", "opacity-0")

    this.element.addEventListener(
      "transitionend",
      () => this.element.remove(),
      { once: true },
    )
  }
}
